import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSlice } from '@reduxjs/toolkit';
import { getCookie } from 'libs/utils/cookies';
import { AuthView, NewsletterSubscription, stateName } from './constants';
export const initialState = {
  referrerId: null,
  isRealNameRequired: false,
  isRandomUserSignupEnabled: false,
  newsletterSubscription: NewsletterSubscription.OptIn,
  isBusinessRegistrationLinkVisible: false,
  isAuthPageOpen: false
};

const openAuthModal = (draft, action) => {
  var _action$payload, _action$payload2;

  const defaultView = getCookie('last_user_id') ? AuthView.SelectTypeLogin : AuthView.SelectTypeRegister;
  draft.isAuthModalOpen = true;
  draft.authView = ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.authView) || defaultView;
  draft.isBusiness = ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.isBusiness) || false;
};

const closeAuthModal = draft => {
  draft.isAuthModalOpen = false;
};

const setAuthView = (draft, action) => {
  const {
    authView
  } = action.payload;
  draft.authView = authView;
};

const setExternalRegisterData = (draft, action) => {
  const {
    view,
    data
  } = action.payload;
  draft.authView = view;
  draft.externalRegisterData = data;
};

const setIsFacebookIsInitialized = draft => {
  draft.isFacebookIsInitialized = true;
};

const setAuthConfigs = (draft, action) => {
  const {
    payload
  } = action;
  return _objectSpread(_objectSpread({}, draft), payload);
};

const setAuthPageOpen = (draft, action) => {
  draft.isAuthPageOpen = action.payload;
};

const authSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    openAuthModal,
    closeAuthModal,
    setAuthView,
    setExternalRegisterData,
    setIsFacebookIsInitialized,
    setAuthConfigs,
    setAuthPageOpen
  }
});
export const {
  actions
} = authSlice;
export const plug = {
  [stateName]: authSlice.reducer
};
export default authSlice.reducer;